// Vendors
import styled from 'styled-components';
import { COBRANDED_LIGHT_REGULAR_BASE_STYLES } from '@openbank/ziniaweb-ui-components';

const PaymentSkeletonComponentStyled = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing_250};
`;
PaymentSkeletonComponentStyled.displayName = 'PaymentSkeletonComponentStyled';

const PaymentSkeletonRowComponentStyled = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${({ theme }) => theme.spacing_200};
  width: 100%;

  ${COBRANDED_LIGHT_REGULAR_BASE_STYLES.MEDIA_QUERIES.onlyMobile} {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing_250};
  }
`;
PaymentSkeletonRowComponentStyled.displayName = 'PaymentSkeletonRowComponentStyled';

export { PaymentSkeletonComponentStyled, PaymentSkeletonRowComponentStyled };
